import { type ChangeEvent, type FC } from "react";

import classNames from "classnames";

import { SupportingText } from "@jti/core-components/components/SupportingText";
import type { ICurrencyEnum } from "@jti/magento";
import { type GetEligibleCampaignsResponseType } from "@jti/rest-api-types";
import { useTranslations } from "@jti/ui";

import { LoyaltyPointsDiscountsList } from "../LoyaltyPointsDiscountsList";

import styles from "./LoyaltyPointsDiscounts.module.scss";

type LoyaltyPointsDiscountsProps = {
  currency: ICurrencyEnum;
  vouchers: GetEligibleCampaignsResponseType[];
  isQueryCampaign: boolean;
  isLoyaltyError: boolean;
  loyaltyCampaignId: string;
  handleCampaignChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const LoyaltyPointsDiscounts: FC<LoyaltyPointsDiscountsProps> = ({
  currency,
  vouchers,
  isQueryCampaign,
  isLoyaltyError,
  loyaltyCampaignId,
  handleCampaignChange,
}) => {
  const { __ } = useTranslations();

  return (
    <div
      data-testid="checkoutRedeemDiscounts"
      className={classNames(styles.container, {
        [styles.containerInProgress]: isQueryCampaign,
      })}
    >
      <LoyaltyPointsDiscountsList
        currency={currency}
        vouchers={vouchers}
        loyaltyCampaignId={loyaltyCampaignId}
        isLoyaltyError={isLoyaltyError}
        handleCampaignChange={handleCampaignChange}
      />

      {isLoyaltyError && (
        <SupportingText data-testid="redeemError" variant="error">
          {__("loyalty.checkout.discountError")}
        </SupportingText>
      )}
    </div>
  );
};
